import { render } from "./DefaultConfirmActionModal.vue?vue&type=template&id=1d66d878"
import script from "./DefaultConfirmActionModal.vue?vue&type=script&lang=js"
export * from "./DefaultConfirmActionModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__